export default function About() {
    return <div className='body-text'>
        Thanks for stopping by.<br />
        All photos were taken by me, Leyang.<br />
        More to come soon!
    </div>
}